import { useGlobalState } from '@libs/client'
import { usePaygates, useSetting } from '@ui/hooks'
import { FC, useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import Loading from '../shared/Loading'
import { hardcodeStaticPage, sleep } from '@ui/helpers'

interface IStaticContent {
  page: string
}

const StaticContent: FC<IStaticContent> = ({ page }) => {
  const [storeSetting] = useSetting('store')

  const title = storeSetting?.general?.name || ''
  let url = storeSetting?.general?.domain || ''
  const paygates = usePaygates()

  const phone = paygates?.paypalex?.contact?.phone || paygates?.creditcard?.contact?.phone || ''
  url = url.replace(/^(https?:\/\/)?/, 'https://')

  const domain = url.replace(/^https?:\/\/?/, '')
  const shop = title || domain
  const email = paygates?.paypalex?.contact?.email || paygates?.creditcard?.contact?.email || ''

  const [_static, setStatic] = useGlobalState<{
    [static_slug: string]: S3Types.default_store_static_page
  }>('static')

  const [isLoading, setIsLoading] = useState(!_static?.[page])

  useEffect(() => {
    ;(async () => {
      if (!_static?.[page]) {
        try {
          setIsLoading(true)
          const _page = (await axios.get(`/api/static/${page}`))
            ?.data as S3Types.default_store_static_page

          const newStatic = { ..._static }
          const dataHardCode = hardcodeStaticPage(domain)[page]
          newStatic[page] = dataHardCode || _page

          setStatic(newStatic)
          await sleep(500)
        } catch (err: any) {
          console.error(err)
        } finally {
          setIsLoading(false)
        }
      } else {
        setIsLoading(false)
      }
    })()
  }, [page])

  const _content = useMemo(() => {
    let contentString = ''
    try {
      const innerContent = JSON.stringify(_static?.[page] || {})
      contentString = innerContent
        .replace(/{{ domain }}/gm, domain)
        .replace(/{{ email }}/gm, `<a href='mailto:${email}'>${email}</a>`)
        .replace(/{{ phone }}/gm, `<a href='tel:${phone}' class='is-phone'>${phone}</a>`)
        .replace(/{{ shop }}/gm, shop)
        .replace(/{{ url }}/gm, url)
        .replace(/[\u{0000}-\u{001F}]/gu, '')
    } catch (err: any) {
      console.error(err)
    }
    return JSON.parse(contentString) as S3Types.default_store_static_page
  }, [page, _static])

  return isLoading ? (
    <Loading isFullWidth />
  ) : (
    <div className="static-content">
      <div className="content__title">{_content.title}</div>
      <div className="content__items">
        {_content &&
          _content?.items?.map((item, index: number) => {
            return (
              <div className="item" key={index}>
                <div
                  className="item__title"
                  dangerouslySetInnerHTML={{ __html: item.title ?? '' }}
                ></div>
                <div className="item__contents">
                  {item?.contents?.map((contentItem, contentIdx: number) => {
                    return (
                      <div
                        className="item__content"
                        key={`${index}_${contentIdx}`}
                        dangerouslySetInnerHTML={{ __html: contentItem }}
                      ></div>
                    )
                  })}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default StaticContent
